import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { formatTextCase, TextCaseMode } from 'src/app/common/utils/text-case.utils';

@Directive({
  selector: 'input[textCase]',
  standalone: true,
})
export class TextCaseDirective {
  @Input() public textCase: TextCaseMode = 'title';
  @Input() public textCaseDisabled: boolean = false;

  constructor(
    private readonly el: ElementRef<HTMLInputElement>,
    private readonly ngControl: NgControl
  ) { }

  @HostListener('input')
  public onInput(): void {
    if (this.textCaseDisabled) {
      return;
    }

    const input = this.el.nativeElement;

    if (input.disabled) {
      return;
    }

    const rawValue = input.value ?? '';
    const formattedValue = formatTextCase(rawValue, this.textCase);

    if (formattedValue === rawValue) {
      return;
    }

    const start = input.selectionStart ?? rawValue.length;
    const end = input.selectionEnd ?? rawValue.length;

    input.value = formattedValue;
    this.ngControl.control?.setValue(formattedValue, { emitEvent: false });

    try {
      input.setSelectionRange(start, end);
    } catch {
    }
  }
}
